import ModelActionsService from 'services/storageModelActions/ModelActionsService';
import { CreateOrderLabelRequestDTO, OrderLabelResponseDTO } from 'typings/dto/orderLabel';
import IOrderLabelActionsService from './IOrderLabelActionsService';
import { PATH_BACKEND } from 'configs/routes/pathsBackend';
import NavigateFrontendUtils from 'utils/NavigateFrontend';

export default class OrderLabelActionsServiceImpl
  extends ModelActionsService<OrderLabel, CreateOrderLabelRequestDTO, OrderLabelResponseDTO>
  implements IOrderLabelActionsService
{
  /** @throws `BackendResponseError` */
  public getValuesFromOrderForFilter = (): Promise<void> => {
    const url = PATH_BACKEND.orderLabel.orderFilter;
    const lso = NavigateFrontendUtils.getLocationSearchObjectFromCurrentLocation();
    const active = lso.active;
    const archiveYear = lso.archiveYear;
    return this.getAllForFilter(undefined, { active, archiveYear }, url);
  };
}
